import { render } from "./etBtnCopyMini.vue?vue&type=template&id=58c12fe9"
import script from "./etBtnCopyMini.vue?vue&type=script&lang=js"
export * from "./etBtnCopyMini.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__